<dx-popup
  [visible]="visible"
  [showTitle]="false"
  [showCloseButton]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.5)"
  [width]="360"
  [height]="'auto'"
>
  <div class="inactivity-warning-content">
    <h2 class="warning-title">Are you still here?</h2>
    <div class="warning-icon">
      <i class="fa-regular fa-clock fa-6x"></i>
    </div>
    <p class="warning-message">
      For security reasons, we'll automatically log you out after being inactive
      for {{ timeoutMinutes }}mins.
    </p>
    <dx-button
      text="Yes, Stay Signed In"
      type="default"
      class="stay-signed-in-button"
      (onClick)="onStaySignedInClick()"
    ></dx-button>
  </div>
</dx-popup>
